
    es-table-nested es-table.nested {
        display: contents;
    }
es-table-nested es-table.nested .odd,
        es-table-nested es-table.nested :where([role='rowgroup']) {
            --row-color: inherit;
        }
es-table-nested es-table.nested :where([role='cell']) {
            --border-bottom-color: var(--color-shade-30);
        }
es-table-nested es-table.nested :where([role='cell']):first-child:not(.borderless) {
                padding-left: 42px;
                position: relative;
                overflow: visible;
            }
es-table-nested es-table.nested :where([role='cell']):first-child:not(.borderless)::after {
                    content: '';
                    position: absolute;
                    background-color: var(--row-color);
                    border-right: 2px solid var(--color-secondary);

                    width: 20px;
                    left: 0;
                    top: -1px;
                    bottom: -1px;
                }
es-table-nested es-table.nested .borderless + .group_first {
            overflow: visible;
            --border-group-color: var(--color-secondary);
        }
es-table-nested es-table.nested .borderless + .group_first::after {
                content: '';
                position: absolute;
                border-left: 2px solid var(--border-group-color);
                left: -2px;
                top: -1px;
                bottom: -1px;
            }
es-table-nested es-table.nested :where(.selectable) [role='cell']:first-child:not(.borderless)::before {
                right: calc(100% - 20px);
            }
es-table-nested .expander {
        height: 100%;
        width: 100%;

        --current-color: var(--color-primary-dark);
    }
es-table-nested .expand_more {
        width: 100%;
        grid-column: 1 / -1;
        background-color: var(--row-color);
        border-bottom: 1px solid var(--color-primary-extra-light);

        --current-color: var(--color-primary-dark);
    }
es-table-nested :where([role='row'].can_expand) {
        font-weight: bold;
        transition: --row-color ease 1000ms;
    }
es-table-nested :where([role='row'].click_to_toggle) {
        cursor: pointer;
    }
es-table-nested :where([role='row'].expanded) {
        --border-bottom-color: var(--color-shade-30);
    }
